import { styled } from 'styled-system/jsx'

const ToolbarRoot = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    flexWrap: 'wrap',
    paddingX: '4px',
  },
})

const FilterRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    flexWrap: 'wrap',
  },
})

const FilterChip = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    backgroundColor: 'transparent',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'pill',
    paddingX: '12px',
    paddingY: '5px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}, background-color {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      color: 'quickpass.primary',
    },
  },
  variants: {
    isActive: {
      true: {
        backgroundColor: 'quickpass.primary',
        borderColor: 'quickpass.primary',
        color: '#FFFFFF',
        _hover: {
          color: '#FFFFFF',
          borderColor: 'quickpass.primary',
        },
      },
    },
  },
})

const ChipGlyph = styled('span', {
  base: {
    fontSize: '13px',
    lineHeight: '1',
  },
})

const SortRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
})

const SortLabel = styled('label', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: 'quickpass.inkSoft',
  },
})

const SortSelect = styled('select', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.ink',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'pill',
    paddingX: '14px',
    paddingY: '6px',
    cursor: 'pointer',
    transition: 'border-color {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
    },
    _focus: {
      outline: 'none',
      borderColor: 'quickpass.primary',
    },
  },
})

const CountHint = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
  },
})

export {
  ToolbarRoot,
  FilterRow,
  FilterChip,
  ChipGlyph,
  SortRow,
  SortLabel,
  SortSelect,
  CountHint,
}
